import { isDefined } from "@clipboard-health/util-ts";
import { Box } from "@mui/material";
import { Span } from "@src/lib/ui-react";
import { type Control, useWatch } from "react-hook-form";

import { MappingLevel, type RequirementMappingFormValues } from "../types";

interface MappingDescriptionProps {
  readonly control: Control<RequirementMappingFormValues>;
}

export function MappingDescription(props: MappingDescriptionProps) {
  const { control } = props;

  const level = useWatch({ control, name: "level" });
  const requiredBy = useWatch({ control, name: "requiredBy" });
  const requiredByHCFs = useWatch({ control, name: "requiredByHCFs" });
  const workplaceTypes = useWatch({ control, name: "workplaceTypes" });
  const qualifications = useWatch({ control, name: "qualifications" });
  const allWorkplaceTypes = useWatch({ control, name: "allWorkplaceTypes" });
  const requiredForBooking = useWatch({ control, name: "requiredForBooking" });
  const domain = useWatch({ control, name: "domain" });

  let hcpTypes = "";
  hcpTypes =
    qualifications.length > 3
      ? `${qualifications.slice(0, 3).join(", ")} +${qualifications.length - 3} more`
      : qualifications.join(", ");

  let hcfTypes = "";
  if (allWorkplaceTypes) {
    hcfTypes = "All workplace types";
  } else if (workplaceTypes.length > 3) {
    hcfTypes = `${workplaceTypes.slice(0, 3).join(", ")} +${workplaceTypes.length - 3} more`;
  } else {
    hcfTypes = workplaceTypes.join(", ");
  }

  return (
    <Box>
      <Span>The </Span>
      <Span fontWeight="bold">document</Span>
      {requiredForBooking && <Span> is required</Span>}
      {!requiredForBooking && <Span> is optional</Span>}
      {level === MappingLevel.HCF && isDefined(requiredByHCFs) && requiredByHCFs.length > 0 && (
        <>
          <Span> at </Span>
          <Span fontWeight="bold">
            {requiredByHCFs.length > 3
              ? `${requiredByHCFs
                  .slice(0, 3)
                  .map((hcf) => hcf.name)
                  .join(", ")} +${requiredByHCFs.length - 3} more`
              : requiredByHCFs.map((hcf) => hcf.name).join(", ")}
          </Span>
        </>
      )}
      {level !== MappingLevel.HCF && isDefined(requiredBy) && requiredBy.length > 0 && (
        <>
          <Span> in </Span>
          <Span fontWeight="bold">
            {requiredBy.length > 3
              ? `${requiredBy.slice(0, 3).join(", ")} +${requiredBy.length - 3} more`
              : requiredBy.join(", ")}
          </Span>
        </>
      )}
      {hcpTypes && (
        <>
          <Span> for </Span>
          <Span fontWeight="bold">{hcpTypes}</Span>
        </>
      )}
      {level !== MappingLevel.HCF && hcfTypes && (
        <>
          <Span> at </Span>
          <Span fontWeight="bold">{hcfTypes}</Span>
        </>
      )}
      {domain && (
        <>
          <Span> for </Span>
          <Span fontWeight="bold">{domain}</Span>
        </>
      )}
    </Box>
  );
}
